// extracted by mini-css-extract-plugin
export default {"DeleteableItemContainer":"DeleteableItem_DeleteableItemContainer__foT+1"};